import { getApiErrorMessage } from "./apiErrors";

// Error messages for the restaurant create/edit form (SFRESTO-139). Owners
// create through POST /restaurant_franchises/{uuid}/restaurants without a
// manager (SFAPI-214, see franchiseRestaurant.ts); managers are added after.

const VIOLATION_MESSAGES: Record<string, string> = {
  "validation.restaurant.error.name.exists":
    "Ce nom de restaurant est déjà utilisé.",
  // Manager checks added by SFAPI-213 (scanifood_api PR #425).
  "validation.restaurant.manager.already_manager":
    "Cette personne gère déjà un restaurant : choisissez un autre manager.",
  "validation.restaurant.manager.not_franchise_member":
    "Cette personne ne fait pas partie de votre franchise.",
};

/** French toast for a failed restaurant create/update (no raw keys). */
export function restaurantSaveErrorMessage(error: unknown): string {
  const violations = (error as { data?: { violations?: unknown[] } | null })
    ?.data?.violations;
  const fallback =
    Array.isArray(violations) && violations.length > 0
      ? "Vérifiez les informations saisies."
      : "Une erreur inconnue est survenue";
  return getApiErrorMessage(error, fallback, { messages: VIOLATION_MESSAGES });
}
